import BaseObject from '../../../base/base_object';

export default class LoginErrorHandlerBase extends BaseObject {
    static CLASS = 'LoginErrorHandlerBase';
    init(params) {
        super.init(params);
        this._serviceFactory = params.serviceFactory;
    }

    get serviceFactory() {
        return this._serviceFactory;
    }

    _handledErrorCode() {
        this.throwError('15', 'Method errorCode is not implemented');
    }

    canHandle(errorProcessingResult) {
        return errorProcessingResult.loginResponse.error_code === this._handledErrorCode();
    }

    handle(errorProcessingResult) {
        this.throwError('23', 'Method execute is not implemented');
    }
}